import gql from 'graphql-tag';
import { memberFields } from './GetMember';

const key = `ListMembersByEmail`;
const query = gql`
query ${key}($email: String!) {
  listMembers(filter:{
    email: { eq : $email }
  }){
    items{
      ${memberFields}
    }
  }
}
`;

export const LIST_MEMBERS_BY_EMAIL = { key, query };
